import styled from 'styled-components';

import {
  flexbox,
  flexDirection,
  justifyContent,
  alignItems
} from '../../styles/helpers/flexbox';

const LoaderContainer = styled.div`
  ${flexbox()};
  ${justifyContent('center')};
  ${alignItems('baseline')};

  flex: 1;
  margin-top: 60px;
  margin-left: 25%;
  position: fixed;
`;

const GridContainer = styled.div((props) => {
  const { colours } = props.theme;

  return `
        ${flexbox()};
        ${flexDirection('column')};

        width: 100%;
        height: fit-content;

        .cell {
            width: 82px;
            height: 40px;
            background: ${colours.grey[300]};
          }
    `;
});

const CellContainer = styled.div((props) => {
  const { colours } = props.theme;

  return `
    ${flexbox()};

    position: relative;
    top: 0;
    border-bottom: 1px solid ${colours.grey[400]};
`;
});

const GridColumn = styled.div`
  ${flexbox()};
  ${flexDirection('column')};
`;

const Header = styled.header((props) => {
  const { colours } = props.theme;
  return `
        ${flexbox()};

        position: sticky;
        top: 192px;
        z-index: 1;
        height: 47px;
        min-height: 47px;
        background-color: ${colours.grey[200]};

        @media screen and (max-width: 1100px) {
          min-height: 37px;
          height: 37px;
          top: 0;
        }
`;
});

const CBContainer = styled.div((props) => {
  const { colours } = props.theme;
  return `
    ${flexbox()};
    ${justifyContent('center')};
    ${alignItems('center')};

    border-right: 1px solid ${colours.grey[400]};
    border-left: 1px solid ${colours.grey[400]};
    background-color: ${colours.grey[200]};
    min-width: 52px;
    height: 47px;

    @media screen and (max-width: 1100px) {
      height: 37px;
    }

    > div {
      margin: 0;
    }
`;
});

export {
  GridContainer,
  Header,
  CellContainer,
  GridColumn,
  LoaderContainer,
  CBContainer
};



// WEBPACK FOOTER //
// ./components/grid/styled.js